import React, { useState } from 'react';
import Sidebar from '../../components/Sidebar';
import { useNavigate } from 'react-router-dom';
import { CMS_ROUTES } from '../../../constants';
import { createAdminUser } from '../../services/api';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  email: Yup.string().email('Ingrese una dirección válida').required('Campo requerido'),
  password: Yup.string().min(8, 'Debe tener al menos 8 caracteres').required('Campo requerido'),
  contact_name: Yup.string().required('Campo requerido'),
  contact_last_name: Yup.string().required('Campo requerido'),
  contact_phone: Yup.string().required('Campo requerido'),
});

const CreateAdminUserPage = () => {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const onSubmit = async (data) => {
    setSubmitting(true);
    setError(null);
    try {
      await createAdminUser(data);
      navigate(CMS_ROUTES.ADMIN_USERS);
    } catch (e) {
      setError(e.response?.data?.message || e.message || 'Error creando usuario');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="users-page cms">
      <div className="main-content">
        <Sidebar />
        <div className="content">
          <h2>Crear Usuario Administrador</h2>
          <hr />
          <form onSubmit={handleSubmit(onSubmit)} className="mt-4" style={{ maxWidth: 600 }}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">Email</label>
              <input id="email" type="email" className={`form-control ${errors.email ? 'is-invalid' : ''}`} {...register('email')} />
              {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">Clave</label>
              <input id="password" type="password" className={`form-control ${errors.password ? 'is-invalid' : ''}`} {...register('password')} />
              {errors.password && <div className="invalid-feedback">{errors.password.message}</div>}
            </div>
            <div className="mb-3">
              <label htmlFor="contact_name" className="form-label">Nombre</label>
              <input id="contact_name" type="text" className={`form-control ${errors.contact_name ? 'is-invalid' : ''}`} {...register('contact_name')} />
              {errors.contact_name && <div className="invalid-feedback">{errors.contact_name.message}</div>}
            </div>
            <div className="mb-3">
              <label htmlFor="contact_last_name" className="form-label">Apellido</label>
              <input id="contact_last_name" type="text" className={`form-control ${errors.contact_last_name ? 'is-invalid' : ''}`} {...register('contact_last_name')} />
              {errors.contact_last_name && <div className="invalid-feedback">{errors.contact_last_name.message}</div>}
            </div>
            <div className="mb-3">
              <label htmlFor="contact_phone" className="form-label">Teléfono</label>
              <input id="contact_phone" type="text" className={`form-control ${errors.contact_phone ? 'is-invalid' : ''}`} {...register('contact_phone')} />
              {errors.contact_phone && <div className="invalid-feedback">{errors.contact_phone.message}</div>}
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            <div className="d-flex gap-2">
              <button type="button" className="btn btn-secondary" onClick={() => navigate(-1)} disabled={submitting}>Cancelar</button>
              <button type="submit" className="btn btn-custom-primary" disabled={submitting}>Crear</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateAdminUserPage; 